// Aucun jeton n'est conservé. Une nouvelle autorisation serveur est exigée
// avant toute réutilisation des portions stockées pour un utilisateur.
export async function createDownloadCache(transfer) {
  const unavailable = { get: async () => null, put: async () => {}, clear: async () => {}, close: () => {}, persistent: false };
  if (typeof indexedDB === 'undefined') return unavailable;
  const db = await new Promise(resolve => {
    let settled = false;
    const finish = value => { if (!settled) { settled = true; clearTimeout(timer); resolve(value); } else value?.close(); };
    const timer = setTimeout(() => finish(null), 2500);
    try {
      const request = indexedDB.open('iptic-application-transfers', 1);
      request.onupgradeneeded = () => {
        const store = request.result.createObjectStore('parts', { keyPath: 'key' });
        store.createIndex('transfer', 'transfer');
        store.createIndex('expires', 'expires');
      };
      request.onsuccess = () => finish(request.result);
      request.onerror = request.onblocked = () => finish(null);
    } catch (_) { finish(null); }
  });
  if (!db) return unavailable;
  db.onversionchange = () => db.close();
  const transact = (mode, action) => new Promise(resolve => {
    try {
      const tx = db.transaction('parts', mode);
      let result = null;
      action(tx.objectStore('parts'), value => { result = value; });
      tx.oncomplete = () => resolve(result);
      tx.onerror = tx.onabort = () => resolve(null);
    } catch (_) { resolve(null); }
  });
  await transact('readwrite', store => {
    const request = store.index('expires').openCursor(IDBKeyRange.upperBound(Date.now()));
    request.onsuccess = () => { const cursor = request.result; if (cursor) { cursor.delete(); cursor.continue(); } };
  });
  return {
    persistent: true,
    get: offset => transact('readonly', (store, done) => {
      const request = store.get(transfer + '|' + offset);
      request.onsuccess = () => { if (request.result?.expires > Date.now()) done(request.result); };
    }),
    put: (offset, blob, sha256) => transact('readwrite', store => {
      store.put({ key: transfer + '|' + offset, transfer, blob, sha256, expires: Date.now() + 24 * 60 * 60 * 1000 });
    }),
    clear: () => transact('readwrite', store => {
      const request = store.index('transfer').openCursor(IDBKeyRange.only(transfer));
      request.onsuccess = () => { const cursor = request.result; if (cursor) { cursor.delete(); cursor.continue(); } };
    }),
    close: () => db.close()
  };
}
